import { rootDomain } from '@/src/store/root-domain';

export const UPDATE_INTERVAL = 10 * 1000;

export const domainKey = 'auth';
export const authDomain = rootDomain.createDomain(domainKey);
